export class ClassroomSummaryPreferences {
    static V10AllOptions : string[] = [];
    static V9AllOptions : string[] = [];
    AvailableOptions: string[] = [];
    OptionsToShow: string[] = [];
    GridColumns = [];
    TermId: number;
    ViewId: number;
    IncludeEmptySections: boolean;
   }